import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PATH } from '../constants/path';

import { convertHtmlToReactDomWithParams } from '../utils/htmlUtils';

import LinkButtonComponent from './button/LinkButtonComponent';

import './CustomerServiceComponent.scss';

class CustomerServiceComponent extends React.Component {
    render() {
        const { i18n } = this.props;

        return (
            <div className={`call-sav ${this.props.cssClass ? this.props.cssClass : ''}`}>
                <h2>{i18n.TITLE}</h2>

                <div className="text">
                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT1)}</p>
                    <p>{convertHtmlToReactDomWithParams(i18n.TEXT2)}</p>
                </div>

                <LinkButtonComponent
                    to={PATH.CONTACTREQUEST_PATH}
                    text={i18n.BUTTON}
                    title="Nous contacter"
                    color="main"
                />
            </div>
        );
    }
}

CustomerServiceComponent.propTypes = {
    cssClass: PropTypes.string
};

const mapStateToProps = state => {
    return {
        i18n: state.i18n.feature.aide.CUSTOMER_SERVICE
    };
};

export default connect(mapStateToProps)(CustomerServiceComponent);



// WEBPACK FOOTER //
// ./src/components/CustomerServiceComponent.js